function getZeroInt(val) {
    if (val < 10) return '0' + val;
    return val + '';
}

function getSelectOptions(object, type) {
    let options = [];
    for (const key in object) {
        var nKey = null;
        if(type != 'fk') {
            if (isNaN(parseInt(key))) {
                nKey = key;
            } else {
                nKey = parseInt(key);
            }
        }
        if (Object.hasOwnProperty.call(object, key)) {
            const element = object[key];
            options.push({
                value: nKey,
                text: element,
            }); 
        }
    }
    return options;
}

function getSelectOptionsBase(listObj, key, title) {
    let options = [];
    listObj.forEach((element) => {
        options.push({
            text: element[title],
            value: element[key],
        });
    });   
    return options; 
}

function getCurrentYear() {
    const date = new Date();
    const cMonth = date.getMonth() + 1;
    if (cMonth < 8) return date.getFullYear() + 1;
    return date.getFullYear();
}

function numberWithSpaces(x) {
    return Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function formatDate(date, format) {
    if (!date) return;
    if (format == 'date' || format == 'datetime') {
        return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
    }
}

function dateFormatPicker(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
}

function normalDivision(value, precision) {
    let res = Math.round(value / precision * 10);
    res = parseInt(res) / 10;
    if(res == parseInt(res)) return res;
    return res;
}

function normalRound(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

function dateTimeFormatPicker(isDateTimeFormat) {
    function wrraper(date) {
        if (!date) return;
        const day = getZeroInt(date.getDate());
        const month = getZeroInt(date.getMonth() + 1);
        const year = date.getFullYear();
        if (!isDateTimeFormat) {
            return `${day}.${month}.${year}`;
        } else {
            const hours = getZeroInt(date.getHours());
            const minutes = getZeroInt(date.getMinutes());
            return `${day}.${month}.${year} ${hours}:${minutes}`;
        }
    }
    return wrraper;
}


export { 
    normalDivision, normalRound,
    dateFormatPicker, formatDate,
    getZeroInt, getSelectOptions, 
    getCurrentYear, getSelectOptionsBase, 
    numberWithSpaces, dateTimeFormatPicker
};